module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "left"
  }, [_c('h1', [_vm._v("Congratulations")]), _vm._v(" "), _c('p', [_vm._v("\n      You found one! That brings your total up to " + _vm._s(_vm.points) + ".\n      "), (_vm.points === 1) ? _c('span', [_vm._v("Keep up the good work to unlock more animals!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "label label--for-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expertMode),
      expression: "expertMode"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expertMode) ? _vm._i(_vm.expertMode, null) > -1 : (_vm.expertMode)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.expertMode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.expertMode = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.expertMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.expertMode = $$c
        }
      }
    }
  }), _vm._v("\n        Expert Mode\n        "), _c('br'), _vm._v(" "), _c('small', [_vm._v("(your cursor won't change when you hover over the cow)")])])]), _vm._v(" "), _c('div', {
    staticClass: "label label--for-select"
  }, [_c('label', [_vm._v("\n        Find a\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.animal),
      expression: "animal"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.animal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.unlockedAnimals), function(animal) {
    return _c('option', {
      domProps: {
        "value": animal.key
      }
    }, [_vm._v("\n            " + _vm._s(animal.name) + "\n          ")])
  }))])]), _vm._v(" "), (_vm.points < _vm.ANIMALS[1].pointsRequired) ? _c('small', {
    staticClass: "tip"
  }, [_vm._v("\n      Get to "), _c('strong', [_vm._v("five points")]), _vm._v(" to unlock another animal\n    ")]) : _vm._e(), _vm._v(" "), (_vm.points >= _vm.ANIMALS[1].pointsRequired && _vm.points < _vm.ANIMALS[2].pointsRequired) ? _c('small', {
    staticClass: "tip"
  }, [_vm._v("\n      Get to "), _c('strong', [_vm._v("fifty points")]), _vm._v(" to unlock the final animal\n    ")]) : _vm._e(), _vm._v(" "), (_vm.points >= _vm.ANIMALS[2].pointsRequired) ? _c('small', {
    staticClass: "tip"
  }, [_vm._v("\n      Congratulations, you’ve unlocked them all!\n    ")]) : _vm._e(), _vm._v(" "), _c('find-button', {
    on: {
      "click": function($event) {
        _vm.setPage(_vm.PAGE_GAME)
      }
    }
  }, [_vm._v("Find a " + _vm._s(_vm.animal))]), _vm._v(" "), _c('find-social-button', {
    attrs: {
      "network": "facebook"
    }
  }), _vm._v(" "), _c('find-social-button', {
    attrs: {
      "network": "twitter"
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "width": "300px",
      "height": "250px"
    },
    attrs: {
      "data-ad-client": "ca-pub-3956850377782988",
      "data-ad-slot": "4677943079"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30a6ec88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Congratulations.vue
// module id = 161
// module chunks = 2